import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { TitleView } from './TitleView/index.jsx'
import { Node } from './Node'
import { PlusButton } from './PlusButton'
import { selectCursorNodeId, moveCursorTo } from '../store/cursor'
import { selectRootNodeChildren, selectNodeById, selectBestChildIdFor } from '../controllers/treeEngine'
import { ROOT_NODE_ID } from '../store/migrations/data-structure-conversion.js'
import { scrollAfterOpeningList } from '../controllers/autoScroll'

const TreeViewComponent = ({
    siblingIds,
    cursorNodeId,
    bestRootChildIdForCursor,
    lastSiblingId,
    title,
    titleNodeId
}) => {
    const dispatch = useDispatch()

    useEffect(() => {
        scrollAfterOpeningList()
    }, [titleNodeId])

    useEffect(() => {
        // bestRootChildIdForCursor exists only if there is no cursor
        if (bestRootChildIdForCursor) {
            dispatch(moveCursorTo(bestRootChildIdForCursor))
        }
    }, [bestRootChildIdForCursor])

    useEffect(() => {
        // Set title
        document.title = title
    }, [title])

    // Render
    return (
        <>
            <TitleView />
            <div id="pageview">
                <div id="code">
                    {siblingIds.map((id) => {
                        const isCursorNode = cursorNodeId === id
                        return <Node key={id} nodeId={id} isCursorNode={isCursorNode} />
                    })}
                    <PlusButton nodeIdBeforeButton={lastSiblingId} />
                </div>
            </div>
        </>
    )
}

function mapStateToProps(state, _ownProps) {
    // cursorNode
    let cursorNodeId = selectCursorNodeId(state)
    const cursorNode = selectNodeById(cursorNodeId)
    cursorNodeId = cursorNode && cursorNodeId

    const titleNode = cursorNode && cursorNode.parent
    const titleNodeId = titleNode && titleNode.id

    // siblings and bestRootChildIdForCursor
    let bestRootChildIdForCursor
    let siblingIds
    if (cursorNodeId) {
        siblingIds = cursorNode.siblingIds
    } else {
        // Dirty fix for race condition causing the app to freeze
        siblingIds = []//selectRootNodeChildren().map((sibling) => sibling.id)

        // if no cursorNode redirect to bestChildId for root node
        bestRootChildIdForCursor = selectBestChildIdFor(ROOT_NODE_ID)
    }

    // last sibling
    const lastSiblingId = siblingIds[siblingIds.length - 1]

    // title
    let title
    // eslint-disable-next-line prettier/prettier
    if (titleNodeId !== ROOT_NODE_ID && (titleNode && !!titleNode.text)) {
        title = `Treelist – ${titleNode.text}`
    } else {
        title = `Treelist`
    }

    return { siblingIds, cursorNodeId, bestRootChildIdForCursor, lastSiblingId, title, titleNodeId }
}

export const TreeView = withRouter(connect(mapStateToProps)(TreeViewComponent))
